<template>
  <v-card  color="blue darken-4" class="pa-5 pt-7">
    <p class="headline font-weight-bold text-center white--text">{{ $t("Welcome to WeNewz") }}</p>
    <p class="text-center title white--text pb-4">{{ $t("We need to learn more about your interests to personalize your feed") }}</p>
    <v-btn block class="success font-weight-bold title mb-3" to="login">
      {{ $t("Login") }}
    </v-btn>
    <v-btn style="color:#0D47A1;" class="font-weight-bold title" block to="register">
      {{ $t("Personalized") }}
    </v-btn>
  </v-card>
</template>

<script>
// Import the i18n export file
import messages from "../../../modules/lang/main/export";
export default {
  // Use it in this file
  i18n: { messages },
  data(){
    return{

    }
  }
}
</script>